import React, { useEffect, useState } from 'react';
import CommonTableList from '../common/common-table-list';
import CommonDetail from '../common/common-detail';
import { ColumnsType } from 'antd/es/table';
import { initVendor, vendor } from '../../model/master';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal, message } from 'antd';
import { isEmpty, validateEmail } from '../../utils/util';
import { api_vendor } from '../../api/vendor';
import VendorDetail from './vendor-detail';
import { printProfileCard } from '../../utils/record-print-utils';
import { deleteFailureMessage } from '../../utils/write-result';

const Vendor: React.FC = (prop) => {

    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('');
    const [title, setTitle] = useState('');
    const [data, setData] = useState<any[]>([]);
    const [vendor, setVendor] = useState<vendor>(initVendor);

    const filterField: any = ['code', 'name', 'tel'];

    const placeholder_txt: string = 'รหัสผู้ขายส่งสินค้า / ชื่อผู้ขายส่งสินค้า / เบอร์โทรศัพท์' 

    const onPrintVendor = (record: any) => {
        printProfileCard('ข้อมูลผู้ขายส่งสินค้า (VENDOR PROFILE)', [
            { label: 'รหัสผู้จำหน่าย', value: record.code },
            { label: 'ชื่อผู้จำหน่าย / บริษัท', value: record.name },
            { label: 'เบอร์โทรศัพท์', value: record.tel },
            { label: 'อีเมล', value: record.email },
            { label: 'ที่อยู่', value: record.address || '-' },
            { label: 'เลขประจำตัวผู้เสียภาษี', value: record.tax_id || '-' }
        ]);
    };

    const columns: ColumnsType<vendor> = [
        { title: 'รหัสผู้ขายส่งสินค้า', dataIndex: 'code', key: 'code', fixed: 'left' },
        { title: 'ชื่อผู้ขายส่งสินค้า', dataIndex: 'name', key: 'name' },
        { title: 'เบอร์โทรศัพท์', dataIndex: 'tel', key: 'tel' },
        { title: 'อีเมล', dataIndex: 'email', key: 'email' },
        { title: 'การดำเนินการ', dataIndex: 'operation', width: '180px', fixed: 'right', render: (_, record) =>
            data.length >= 1 ? ( 
                <div className='iconOperation'>
                    <FontAwesomeIcon icon="eye" title="ดูรายละเอียด" onClick={() => { onShowDetail('VIEW', record) }} />
                    <FontAwesomeIcon icon="print" title="พิมพ์ข้อมูลผู้ขายส่ง" onClick={() => { onPrintVendor(record) }} />
                    <FontAwesomeIcon icon="pen-to-square" title="แก้ไข" onClick={() => { onShowDetail('EDIT', record); }} />
                    <FontAwesomeIcon icon="trash-can" title="ลบ" onClick={() => { onDelete(record.id) }} />
                </div>
            ) : null
        }
    ]

    const init = async () => {
        setData([]);
        try {
            const getVendor = await api_vendor('LIST', {});
            setData(Array.isArray(getVendor) ? getVendor : []);
        } catch (e: any) {
            // `api_vendor` used to swallow this and hand back an empty
            // list, so an outage looked like a shop with no suppliers.
            setData([]);
            message.error(e?.response?.data?.message || e?.message || 'โหลดข้อมูลผู้ขายส่งไม่สำเร็จ');
        }
    }

    const getConfigModal = (titile: string, content: string) => {
        return {
            title: titile,
            icon: <ExclamationCircleFilled rev={undefined} />,
            content: content,
            okText: 'ตกลง',
            cancelText: 'ยกเลิก',
            centered: true
        }
    }

    const onShowDetail = (mode: string, vendorData?: vendor) => {
        if (mode === 'ADD' || mode === 'COPY') {
            setTitle('เพิ่มผู้ขายส่งสินค้าย')
        } else if (mode === 'EDIT') {
            setTitle('แก้ไขผู้ขายส่งสินค้า')    
        } else if (mode === 'VIEW') {
            setTitle('รายละเอียดผู้ขายส่งสินค้า')
        }

        setMode(mode);
        setVendor(vendorData !== undefined && vendorData !== null ? vendorData : initVendor);
        setOpen(true);
    };

    const onCloseDetail = () => {
        setOpen(false);
    };

    const onSave = async () => {
        let operation = 'INSERT';
        let key_id = undefined;
        let body = JSON.parse(JSON.stringify(vendor));
        if (vendor.id > 0) {
            operation = 'UPDATE';
            key_id = vendor.id;
        }

        if (!isEmpty(body['email']) && !validateEmail(body['email'])) {
            Modal.warning({
                ...getConfigModal('แจ้งเตือน', 'กรุณากรอกอีเมลให้ถูกต้อง')
            });
        } else if (!isEmpty(body['name']) && !isEmpty(body['tel'])) {
            body['code'] = isEmpty(body['code']) ? null : body['code']
            body['name'] = isEmpty(body['name']) ? null : body['name']
            body['tax_id'] = isEmpty(body['tax_id']) ? null : body['tax_id']
            body['tel'] = isEmpty(body['tel']) ? null : body['tel']
            body['fax'] = isEmpty(body['fax']) ? null : body['fax']
            body['email'] = isEmpty(body['email']) ? null : body['email']
            body['address'] = isEmpty(body['address']) ? null : body['address']
            body['remark'] = isEmpty(body['remark']) ? null : body['remark']

            let res = await api_vendor(operation, body, key_id);
            if (res === 1) {
                setOpen(false);
                Modal.success({
                    ...getConfigModal('สำเร็จ', operation === 'UPDATE' ? 'แก้ไขข้อมูลสำเร็จแล้ว' : 'เพิ่มข้อมูลสำเร็จแล้ว'),
                    ...{ onOk() { init(); }}
                });
            } else {
                Modal.error({
                    ...getConfigModal('ผิดพลาด', operation === 'UPDATE' ? 'แก้ไขข้อมูลไม่สำเร็จ' : 'เพิ่มข้อมูลไม่สำเร็จ'),
                });
            }
        } else {
            Modal.warning({
                ...getConfigModal('แจ้งเตือน', 'กรุณากรอกข้อมูลให้ครบถ้วน')
            });
        }
    }

    const onDelete = async (key_id: number) => {
        Modal.confirm({
            ...getConfigModal('แจ้งเตือน', 'คุณต้องการลบข้อมูลนี้หรือไม่ ?'),
            ...{
                async onOk() { 
                    try {
                        let res = await api_vendor('DELETE', {}, key_id);
                        if (res === 1) {
                            Modal.success({
                                ...getConfigModal('สำเร็จ', 'ลบข้อมูลสำเร็จแล้ว'),
                                ...{ onOk() { init(); }}
                            });
                        } else {
                            Modal.error({
                                ...getConfigModal('ผิดพลาด', 'ลบข้อมูลไม่สำเร็จ'),
                            });
                        }
                    } catch (err: any) {
                        // Backend answers a record that is already gone with a
                        // specific 404 and a sentence written for the user. Showing
                        // only "ลบข้อมูลไม่สำเร็จ" threw that away and left them
                        // guessing whether it was the network, their permissions, or
                        // a colleague who deleted it first.
                        Modal.error({
                            ...getConfigModal('ผิดพลาด', deleteFailureMessage(err, 'ลบข้อมูลไม่สำเร็จ')),
                        });
                    }
                }
            }
        });
    }

    const onDataDetailChange = (payload: any) => {
        setVendor(payload)
    }

    useEffect(() => {
        init();
    }, []);

    return (
        <>
            {/* { data.length > 0 ? <CommonTableList page='vendor' placeholder={placeholder_txt} columns={columns} data={data} filterField={filterField} onAdd={() => { onShowDetail('ADD') }} /> : null } */}
            <CommonTableList page='vendor' placeholder={placeholder_txt} columns={columns} data={[...data]} filterField={filterField} onAdd={() => { onShowDetail('ADD') }} />
            <CommonDetail width='40%' mode={mode} title={title} open={open} onClosed={onCloseDetail} onSaved={onSave} element={ <VendorDetail vendor={{...vendor}} onChange={onDataDetailChange} /> } />
        </>
    );
}

export default Vendor;